import { render, staticRenderFns } from "./BotaoArmazem.vue?vue&type=template&id=01da84ce&lang=pug"
import script from "./BotaoArmazem.vue?vue&type=script&lang=js"
export * from "./BotaoArmazem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports